/**
 * Minimum distance from floor (12 inches in meters)
 */
export const MIN_FLOOR_DISTANCE = 0.3048;
